import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabase';

// KEEP IN SYNC with the cap inside auto_assign_founding() — see migration 063.
export const FOUNDING_CAP = 33;

async function fetchSpotsRemaining(): Promise<number> {
  // Slots are consumed by founding_number-ever, matching the DB trigger
  // shops_auto_founding — NOT by current tier. A founder that converts to
  // pro keeps its number, so its slot must still read as taken.
  const { count, error } = await supabase
    .from('shops')
    .select('id', { count: 'exact', head: true })
    .not('founding_number', 'is', null);
  if (error || count === null) return FOUNDING_CAP;
  return Math.max(0, FOUNDING_CAP - count);
}

export function useFoundingSpotsRemaining() {
  return useQuery({
    queryKey: ['founding-spots-remaining'],
    queryFn: fetchSpotsRemaining,
    staleTime: 60 * 1000,
  });
}
